import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var pool = {};
var recreateFetchPool = {};
/**
 * A REST nonce in WordPress is only valid for 12 hours (can be configured). However, if it gets
 * invalid, the REST endpoints return a `403` error which signals us, we should recreate the nonce.
 * To avoid multiple recreations, we memorize the newly created nonce in a pool.
 */

function nonceDeprecationPool(_x, _x2) {
  return _nonceDeprecationPool.apply(this, arguments);
}

function _nonceDeprecationPool() {
  _nonceDeprecationPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nonce, restRecreateNonceEndpoint) {
    var resultPromise, returnNonce;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof restRecreateNonceEndpoint !== "undefined")) {
              _context2.next = 6;
              break;
            }

            resultPromise = // Reuse already sent request
            recreateFetchPool[nonce] || new Promise(
            /*#__PURE__*/
            // eslint-disable-next-line no-async-promise-executor
            function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                var recreateFetch, newNonce;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return window.fetch(restRecreateNonceEndpoint);

                      case 3:
                        recreateFetch = _context.sent;

                        if (!recreateFetch.ok) {
                          _context.next = 12;
                          break;
                        }

                        _context.next = 7;
                        return recreateFetch.text();

                      case 7:
                        newNonce = _context.sent;
                        pool[nonce] = newNonce;
                        resolve(newNonce);
                        _context.next = 13;
                        break;

                      case 12:
                        reject();

                      case 13:
                        _context.next = 18;
                        break;

                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](0);
                        reject();

                      case 18:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 15]]);
              }));

              return function (_x3, _x4) {
                return _ref.apply(this, arguments);
              };
            }());
            recreateFetchPool[nonce] = resultPromise;
            return _context2.abrupt("return", resultPromise);

          case 6:
            if (!(typeof nonce === "undefined")) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 8:
            _context2.next = 10;
            return Promise.all(Object.values(recreateFetchPool));

          case 10:
            returnNonce = nonce;

            while (pool[returnNonce]) {
              returnNonce = pool[returnNonce];
            }

            return _context2.abrupt("return", Promise.resolve(returnNonce));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _nonceDeprecationPool.apply(this, arguments);
}

export { nonceDeprecationPool };